import Badge from "./Badge"

export default function GameCard({ name, status, image }) {
  return (
    <div className="relative group overflow-hidden rounded-lg">
      <div className="aspect-[3/4] relative">
        <img
          src={image || "placeholder.jpg"}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
      </div>

      <div className="absolute bottom-0 left-0 w-full p-4">
        <h3 className="text-xl font-bold">{name}</h3>
        {status === "active" ? (
          <Badge className="bg-green-500 hover:bg-green-600">Available Now</Badge>
        ) : (
          <Badge variant="outline" className="border-yellow-500 text-yellow-500">
            Coming Soon
          </Badge>
        )}
      </div>
    </div>
  )
}

